import React, { useState } from "react";

import Groups from "../../pages/Groups";
import Group from "../../pages/Group";

import Activities from "../../pages/Activities";
import ActivityTasks from "../../pages/Tasks";

import StoriesGallery from "../../pages/StoriesGallery"; 

import { CalendarOutlined, BookOutlined } from "@ant-design/icons";

import { Tabs, Card } from "antd";

import { useLocation } from "react-router-dom";

const { TabPane } = Tabs;

const StudentDashboard = () => {

  const location = useLocation();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(
    location.state?.selectedActivity || null
  );

  return (

   <div className="dashboard-wrapper">
      <Card className="panel-card">
        <Tabs defaultActiveKey="Groups" className="main-tabs" tabBarGutter={40}>
          {/* GROUPS TAB */}
         {/*  <TabPane
            key="Groups"
            tab={
              <span className="tab-label">
                <NodeIndexOutlined /> Gruppen
              </span>
            }
          >
            {selectedGroup ? (
              <Group
                group={selectedGroup}
                onBack={() => setSelectedGroup(null)}
              />
            ) : (
              <Groups onSelect={setSelectedGroup} />
            )}
          </TabPane> */}

          {/* ACTIVITIES TAB */}
          <TabPane
            key="Activities"
            tab={
              <span className="tab-label">
                <CalendarOutlined /> Aktivitäten
              </span>
            }
          >
            {selectedActivity ? (
            
             <ActivityTasks
                activity={selectedActivity}
                onBack={() => setSelectedActivity(null)}
              />
            ) : (
              <div> 
              <div className="separator3">Deine Aktivitäten</div>
              <Activities onSelect={setSelectedActivity} />
              </div>
            )}
          </TabPane>

          {/* STORIES TAB */}
          <TabPane
            key="Stories"
            tab={
              <span className="tab-label">
                <BookOutlined /> Geschichten
              </span>
            }
          >
            <div className="separator3">Entdecken unsere Geschichten</div>
            <StoriesGallery /> {/* Render the stories gallery here */}
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default StudentDashboard;